import React from 'react';
import PropTypes from 'prop-types';
import Input from 'cd-ui-react/components/input';
import Icon from 'cd-ui-react/components/icon';
import styles from './input.css';
import cx from 'classnames';
import {KeyCodes} from '../../utils/ComponentsUtil';
import {i18n} from '../../utils/GadgetUtils';

class InputWithClear extends React.Component {
	constructor (props) {
		super(props);
		this.onChange = this.onChange.bind(this);
		this.clearText = this.clearText.bind(this);
	}
	onChange (e) {
		this.props.onChange(e);
	}

	clearText (e) {
		this.props.onClear();
		if (e) {
			e.target.previousElementSibling.focus();
		}
	}

	onKeyDown = e => {
		if (e.keyCode === KeyCodes.KEY_ENTER) this.clearText();
	}

	clickOnSearchIcon = event => {
		// set focus on input box
		event.currentTarget.parentElement.firstChild.focus();
	};

	render () {
		const {value, clearable, searchable, className, onClear, ...otherProps} = this.props;
		let clearableStyle = cx({
			[`${styles.show}`]: this.props.value,
			[`${styles.hide}`]: !this.props.value
		});

		let inputStyle = cx(className, {
			[`${styles.searchableInput}`]: this.props.searchable,
			[`${styles.clearableInput}`]: this.props.clearable
		});
		return (<div className={styles.input}>
			<Input data-input
				className={inputStyle}
				value={this.props.value}
				onChange={this.onChange}
				placeholder={searchable ? `${i18n.getMsg('search.label')}` : (this.props.placeholder || '')}
				{...otherProps} onFocus={() => { this.value = this.value; }} />
			{clearable && <a data-clear-input role="button" aria-label={i18n.getMsg('gadget.callcontrol.operation.clearText')} className={clearableStyle} tabIndex="0"
				onClick={this.clearText} onKeyDown={this.onKeyDown} color="grey">&#x2715;
			</a>}
			{searchable &&
			<span data-search-input onClick={this.clickOnSearchIcon}>
				<Icon name="search" color="#aeaeaf" size={this.props.smallsearchiconsize || "18"} />
			</span>}
		</div>
		);
	}
}

InputWithClear.propTypes = {
	/* Value of the input component  */
	value: PropTypes.string,
	/* Callback function to be called when clear icon is clicked */
	onClear: PropTypes.func,
	/* Callback function when input value changes */
	onChange: PropTypes.func,
	/* Boolean flag to indicate if it is a clearable input */
	clearable: PropTypes.bool,
	/* Boolean flag to indicate if it is a searchable input */
	searchable: PropTypes.bool,
	/* Additional css to be applied on the input component */
	className: PropTypes.string,
	/* Placeholder string on the component */
	placeholder: PropTypes.string,
	/* Size for small search icon */
	smallsearchiconsize: PropTypes.string
};

InputWithClear.defaultProps = {
	clearable: true,
	searchable: false
};

export default InputWithClear;
